import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { makeStyles } from 'tss-react/mui';

import { policies } from '@lumirental/lumi-web-shared/lib/constants/IR/content';
import { useConfigContext } from '@lumirental/lumi-web-shared/lib/contexts/Config.context';
import { useLanguageContext } from '@lumirental/lumi-web-shared/lib/contexts/Language.context';
import getPublicCDNLink from '@lumirental/lumi-web-shared/lib/utils/cdnLinks/getPublicCDNLink';

import styles from './Policies.style';

const useStyles = makeStyles()(styles);
export default function PoliciesBlock() {
  const { classes } = useStyles();
  const { language } = useLanguageContext();
  const { appEnv } = useConfigContext();

  return (
    <Grid container columnSpacing={3} justifyContent="start">
      <Typography variant="h3" className={classes.title}>
        {policies.title[language]}
      </Typography>
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          {policies?.list?.map((item) => {
            const { title, url } = item;
            return (
              <Box key={title[language]} className={classes.file}>
                <Typography variant="body1" className={classes.fileName}>
                  {title[language]}
                </Typography>
                <Box
                  as="a"
                  href={getPublicCDNLink(url[language], appEnv)}
                  download={title[language]}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className={classes.downloadIcon}
                >
                  <img src="/images/png/download.png" alt="Download Icon" />
                </Box>
              </Box>
            );
          })}
        </CardContent>
      </Card>
    </Grid>
  );
}
